import { render, staticRenderFns } from "./permission_settings.vue?vue&type=template&id=2b998a89&"
import script from "./permission_settings.vue?vue&type=script&lang=js&"
export * from "./permission_settings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports